import { PlanDetails } from '@/contexts/plans'
import { PaymentsCard, ReceivingOptions } from '@/types/fees'

export function getPlanFeeByReceivingOptionAndFlag(
  plan: PlanDetails,
  receivingOption: ReceivingOptions,
  cardBrand: PaymentsCard
) {
  const condition = plan.conditions.find(
    (item) => item.anticipation_delay === receivingOption
  )

  const mdrs =
    condition?.mdrs.filter((mdr) => mdr.card_brand === cardBrand) || []

  const debitCard = mdrs.find((mdr) => mdr.payment_method === 'debit_card')
  const [debitCardFirstInstallment] = debitCard?.installments || []

  const creditCard = mdrs.find((mdr) => mdr.payment_method === 'credit_card')

  const creditCardInstallments = creditCard?.installments || []
  const creditCardMDRs = creditCardInstallments.map(
    (installment) => installment.mdr
  )

  return [debitCardFirstInstallment.mdr, ...creditCardMDRs]
}
